/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcChevronDownSmallRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M5.363 9.364a.9.9 0 0 1 1.273 0L12 14.727l5.363-5.363a.9.9 0 0 1 1.273 1.272l-6 6a.9.9 0 0 1-1.273 0l-6-6a.9.9 0 0 1 0-1.272"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcChevronDownSmallRegular;
